// Components
import { ClassificationForm } from "./ClassificationForm";

const EditClassification = () => {
  return <ClassificationForm edit />;
};

export { EditClassification };
